import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, trackPageView } from '../utils/analytics';

// Starts analytics once and records a page view on every route change.
const AnalyticsTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    // Wait a tick so the page has set its own title before the view is recorded.
    const timer = setTimeout(() => trackPageView(pathname), 0);
    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
};

export default AnalyticsTracker;
